import { useEffect, useState } from "react";

import { sortByField } from "../../utils/Sort";

import "./KochLocationFilter.css";
import NitroFilter from "../NitroFilter";
import { OccupantsIcon } from "../../icons";
import { IFavoriteOrigin, IFavoriteOriginOptionExtension } from "../../types/IFavoriteOrigins";
import NitroService from "../../utils/nitro.service";

const LocationIdFilter = ({
  value,
  setValue,
  isFavoriteOrigins,
  isCompetitor,
  favoriteOrigins,
  config,
  isMobile,
}: {
  value: string;
  setValue: (value: { id: string; name: string; products?: string[] }) => void;
  isFavoriteOrigins: boolean;
  isCompetitor?: boolean;
  favoriteOrigins?: IFavoriteOrigin[];
  config?: {
    customPaper?: boolean;
    shadow?: boolean;
    opaque?: boolean;
    autoFocus?: boolean;
    inputRef?: React.MutableRefObject<any> | null;
    valueRequired?: boolean;
  };
  isMobile?: boolean;
}) => {
  const [options, setOptions] = useState<IFavoriteOriginOptionExtension[]>([]);
  const [isLoadingOptions, setIsLoadingOptions] = useState(isFavoriteOrigins);

  useEffect(() => {
    const getLocations = async () => {
      if (isCompetitor) {
        return NitroService.getCompetitorLocations();
      }
      return NitroService.getKochLocations();
    };
    const load = async () => {
      if (isFavoriteOrigins) {
        setIsLoadingOptions(true);
      }
      try {
        const records = !isFavoriteOrigins
          ? await NitroService.getKochAndCompetitorLocations()
          : await getLocations();
        const favoriteOriginsIds =
          isFavoriteOrigins && favoriteOrigins
            ? favoriteOrigins.map((o) => o.location.id)
            : [];
        const sorted: IFavoriteOriginOptionExtension[] = [
          { id: "", name: "" },
          ...sortByField(records, "name", "ASC"),
        ];
        const filtered = isFavoriteOrigins
          ? sorted.filter((l) => !favoriteOriginsIds.includes(l.id))
          : sorted;
        setOptions(filtered);
      } finally {
        if (isFavoriteOrigins) {
          setIsLoadingOptions(false);
        }
      }
    };
    load();
  }, [favoriteOrigins, isCompetitor, isFavoriteOrigins]);

  return (
    <NitroFilter
      isFavoriteOrigins={isFavoriteOrigins}
      placeholder="Choose facility name"
      size="small"
      data={{
        options: options.map((l) => {
          return { label: l.name || "", value: l.name };
        }),
      }}
      value={value}
      setValue={(v: string) => {
        const found = options.find((r) => r.name === v);
        setValue({
          id: found?.id || "",
          name: v,
          products: found?.products,
        });
      }}
      isMobile={isMobile}
      config={config}
      Icon={<OccupantsIcon color="#383838" />}
      isLoadingOptions={isFavoriteOrigins ? isLoadingOptions : undefined}
    />
  );
};

export default LocationIdFilter;
